import classNames from "classnames";
import { ReactNode } from "react";
import { Icon } from "../icon/icon";

interface InfoCardProps {
  leftIcon?: string;
  leftClassName?: string;
  title?: ReactNode;
  text?: ReactNode;
  rightIcon?: string;
  className?: string;
  rightElement?: ReactNode;
  iconDimensions?: number;
  onClick?: () => void;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  leftIcon = "",
  leftClassName = "",
  title = "",
  text = "",
  rightIcon = "",
  className = "",
  rightElement,
  iconDimensions = 24,
  onClick,
}) => {
  return (
    <div
      className={classNames(
        `flex w-full gap-4 rounded-2xl bg-light-green p-4 text-left text-sm text-primary md:items-center ${className}`,
        {
          "cursor-pointer": onClick,
        },
      )}
      onClick={onClick}
    >
      {leftIcon && (
        <Icon
          svg={leftIcon}
          width={iconDimensions}
          height={iconDimensions}
          className={`min-w-fit ${leftClassName}`}
        />
      )}

      <div className="flex-1">
        <div className="font-bold">{title}</div>
        <div className="mt-[2px] text-grey-900">{text}</div>
      </div>

      {rightIcon && (
        <Icon svg={rightIcon} width={24} height={24} className="min-w-fit" />
      )}

      {rightElement}
    </div>
  );
};
